import React from "react";
import { useT, Namespace } from "@racoon/i18n";
import { FilterBlock, Button } from "@racoon/ui";

interface TruckTypeStatusFilterProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  onCreateClick: () => void;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
  onArchiveClick?: () => void;
  onRestoreClick?: () => void;
}

export const TruckTypeStatusFilter: React.FC<TruckTypeStatusFilterProps> = ({
  searchValue,
  onSearchChange,
  onCreateClick,
  onEditClick,
  onDeleteClick,
}) => {
  const t = useT();

  return (
    <FilterBlock
      direction="row"
      bgColor="white"
      searchValue={searchValue}
      onSearchChange={onSearchChange}
      additionalButtonsPosition="bottom"
      additionalButtons={
        <div className=" flex gap-2">
          {onEditClick && (
            <Button size="sm" variant="opacityBlueWithOutline" onClick={onEditClick}>
              {t(Namespace.Buttons, "edit")}
            </Button>
          )}
          {onDeleteClick && (
            <Button size="sm" variant="opacityRedWithOutline" onClick={onDeleteClick}>
              {t(Namespace.Buttons, "delete")}
            </Button>
          )}
          <Button size="sm" variant="opacityBlueWithOutline" onClick={onCreateClick}>
            {t(Namespace.Settings, "truckType.addButton")}
          </Button>
        </div>
      }
    />
  );
};
